import { TextField } from "@mui/material";
import { useState, useEffect } from "react";

import { useDebounce } from "../../../../../hooks/useDebounce";
import { useQueryParams } from "../../../../../hooks/useQueryParams";
import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import { STRINGS } from "../../utils/strings";

const CaseListSearch = () => {
  const { filters, updateFilter } = useQueryParams();
  const initialVal = filters.get("search") || "";
  const [searchVal, setSearchVal] = useState(initialVal);
  const debouncedSearch = useDebounce(searchVal, 300);

  useEffect(() => {
    updateFilter("search", debouncedSearch || null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  useEffect(() => {
    if (!initialVal) {
      setSearchVal("");
    }
  }, [initialVal]);

  return (
    <div className="inline-flex items-center py-1 pl-3 border border-gray-400 rounded-full">
      <Svg name={SvgEnum.HisMagnifyingGlass} />
      <TextField
        className="w-full text-sm rounded-lg placeholder:text-center"
        placeholder={STRINGS.SEARCH_PLACEHOLDER}
        size="small"
        name="case-search"
        value={searchVal}
        InputLabelProps={{
          shrink: true,
          style: {
            border: "none",
          },
        }}
        onChange={(event) => {
          setSearchVal(event.target.value);
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "none",
            },
            "&:hover fieldset": {
              border: "none",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
          },
        }}
      />
    </div>
  );
};

export default CaseListSearch;
